import { GridProps, SxProps } from '@mui/material'
import StylesProductListServiceInterface
  from '~/src/components/products/product-list/styles/StylesProductListServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesProductListServiceStyleFour extends TemplateServiceStyleBase implements StylesProductListServiceInterface {
  public getGridProps(): Pick<GridProps, 'columns'> {
    return {
      columns: 12
    }
  }

  public getGridListItemProps(): Pick<GridProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl'> {
    return {
      xl: 4,
      lg: 6,
      md: 12,
      sm: 6,
      xs: 12
    }
  }

  public getGridStyleSxProps(): SxProps {
    return {
      p: 0,
      [this.muiTheme.breakpoints.down('md')]: {
        px: 2
      }
    }
  }
}
